import { lazy, Suspense } from 'react';
import NotFound from './components/NotFound';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import { SiteProvider } from './context/SiteContext';
import Layout from './components/Layout';
const AdminLayout = lazy(() => import('./components/AdminLayout'));
const AdminLogin = lazy(() => import('./pages/admin/AdminLogin'));
const AdminDashboard = lazy(() => import('./pages/admin/AdminDashboard'));
const AdminPosts = lazy(() => import('./pages/admin/AdminPosts'));
const AdminPostEditor = lazy(() => import('./pages/admin/AdminPostEditor'));
const AdminBanners = lazy(() => import('./pages/admin/AdminBanners'));
const AdminLandingPages = lazy(() => import('./pages/admin/AdminLandingPages'));
const AdminLandingEditor = lazy(() => import('./pages/admin/AdminLandingEditor'));
const AdminPages = lazy(() => import('./pages/admin/AdminPages'));
const AdminProjects = lazy(() => import('./pages/admin/AdminProjects'));
const AdminUsers = lazy(() => import('./pages/admin/AdminUsers'));
const AdminContacts = lazy(() => import('./pages/admin/AdminContacts'));
const AdminSettings = lazy(() => import('./pages/admin/AdminSettings'));
const AdminAds = lazy(() => import('./pages/admin/AdminAds'));
const AdminCategories = lazy(() => import('./pages/admin/AdminCategories'));
const AdminServices = lazy(() => import('./pages/admin/AdminServices'));
const AdminComments = lazy(() => import('./pages/admin/AdminComments'));
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import News from './pages/News';
import NewsDetail from './pages/NewsDetail';
import Pricing from './pages/Pricing';
import ServiceDetail from './pages/ServiceDetail';
const AIImageTool = lazy(() => import('./pages/AIImageTool'));
import Recruitment from './pages/Recruitment';
import CompanyProfile from './pages/CompanyProfile';
const KhoanCocNhoiLanding = lazy(() => import('./pages/landing/KhoanCocNhoiLanding'));
const ChongLunLanding = lazy(() => import('./pages/landing/ChongLunLanding'));
const PreviewPremium = lazy(() => import('./pages/landing/PreviewPremium'));
const PreviewLeadGen = lazy(() => import('./pages/landing/PreviewLeadGen'));
const DynamicLandingPage = lazy(() => import('./pages/landing/DynamicLandingPage'));
import ScrollToTop from './components/ScrollToTop';
import PageLoadingBar from './components/PageLoadingBar';

export default function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <SiteProvider>
          <BrowserRouter>
            <ScrollToTop />
            <PageLoadingBar />
            <Suspense fallback={<div role="status" className="min-h-[50vh] flex items-center justify-center text-primary">Đang tải trang…</div>}>
            <Routes>
              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="posts" element={<AdminPosts />} />
                <Route path="posts/new" element={<AdminPostEditor />} />
                <Route path="posts/edit/:id" element={<AdminPostEditor />} />
                <Route path="banners" element={<AdminBanners />} />
                <Route path="services" element={<AdminServices />} />
                <Route path="ads" element={<AdminAds />} />
                <Route path="categories" element={<AdminCategories />} />
                <Route path="projects" element={<AdminProjects />} />
                <Route path="landing-pages" element={<AdminLandingPages />} />
                <Route path="landing-pages/new" element={<AdminLandingEditor />} />
                <Route path="landing-pages/edit/:id" element={<AdminLandingEditor />} />
                <Route path="pages" element={<AdminPages />} />
                <Route path="users" element={<AdminUsers />} />
                <Route path="contacts" element={<AdminContacts />} />
                <Route path="comments" element={<AdminComments />} />
                <Route path="ai-tool" element={<AIImageTool />} />
                <Route path="settings" element={<AdminSettings />} />
              </Route>

              {/* Landing Pages Cũ (Phục hồi giữ link đang chạy ads) */}
              <Route path="/landing/khoan-coc-nhoi" element={<KhoanCocNhoiLanding />} />
              <Route path="/landing/chong-lun" element={<ChongLunLanding />} />
              
              {/* Landing Pages Preview (Cho Khách Hàng Xem Trước) */}
              <Route path="/landing/preview-premium" element={<PreviewPremium />} />
              <Route path="/landing/preview-leadgen" element={<PreviewLeadGen />} />
              
              {/* Landing Pages Mới (Dynamic) */}
              <Route path="/landing/:slug" element={<DynamicLandingPage />} />

              <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="gioi-thieu" element={<About />} />
              <Route path="lien-he" element={<Contact />} />
              <Route path="tin-tuc" element={<News />} />
              <Route path="tin-tuc/:slug" element={<NewsDetail />} />
              <Route path="ho-so-nang-luc" element={<CompanyProfile />} />
              <Route path="bang-gia" element={<Pricing />} />
              <Route path="tuyen-dung" element={<Recruitment />} />
              <Route path="dang-ky" element={<Contact />} />
              
              {/* Dynamic route for all services, districts, and sizes */}
              <Route path=":slug" element={<ServiceDetail />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
          </Suspense>
        </BrowserRouter>
        </SiteProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}
